import { defineComponent, ref, computed } from "vue";
import { useReviewsStore } from "./customerReviewsStore";
import EmptyStarImage from "../../assets/stars/emptyStar.png";
import HalfStarImage from "../../assets/stars/halfStar.png";
import FullStarImage from "../../assets/stars/fullStar.png";
import { ratingFilterEnum, surveyTypeFilterEnum } from "./utilities/helpers";
export default defineComponent({
    name: "Filters",
    components: {},
    setup() {
        const store = useReviewsStore();
        const defaultSurveyType = surveyTypeFilterEnum.Overall;
        let FilterTypeEnum;
        (function (FilterTypeEnum) {
            FilterTypeEnum["Rating"] = "Rating";
            FilterTypeEnum["Model"] = "Model";
            FilterTypeEnum["SurveyType"] = "SurveyType";
        })(FilterTypeEnum || (FilterTypeEnum = {}));
        const ratingsContainer = ref(null);
        const maxRatingsLengthStylingWidth = ref("");
        const filteredReviewsCount = computed(() => store.getFilteredReviewsCount.toString() + " reviews");
        const filteredReviewsAverage = computed(() => store.getFilteredReviewsAverage
            .toString()
            .substring(0, parseInt(store.getFilteredReviewsAverage).toFixed(2).toString()
            .length - 1) + " average");
        const filteredStarCounts = computed(() => {
            const starCounts = {
                one: 0,
                two: 0,
                three: 0,
                four: 0,
                five: 0,
            };
            store.pages.forEach((page) => {
                if (page.length > 0) {
                    page.forEach((review) => {
                        switch (review.rating) {
                            case "1":
                                starCounts.one++;
                                break;
                            case "2":
                                starCounts.two++;
                                break;
                            case "3":
                                starCounts.three++;
                                break;
                            case "4":
                                starCounts.four++;
                                break;
                            case "5":
                                starCounts.five++;
                                break;
                            default:
                                break;
                        }
                    });
                }
            });
            updateMaxRatingsLength(starCounts);
            return starCounts;
        });
        const modelFilters = store.getmodelFilters();
        const surveyTypeFilters = store.getSurveyTypeFilters();
        function updateMaxRatingsLength(starCounts) {
            const starCountLengths = [
                starCounts.one.toString().length,
                starCounts.two.toString().length,
                starCounts.three.toString().length,
                starCounts.four.toString().length,
                starCounts.five.toString().length,
            ];
            const maxRatingsLength = Math.max(...starCountLengths);
            switch (maxRatingsLength) {
                case 1:
                    maxRatingsLengthStylingWidth.value = "80px";
                    break;
                case 2:
                    maxRatingsLengthStylingWidth.value = "90px";
                    break;
                case 3:
                    maxRatingsLengthStylingWidth.value = "100px";
                    break;
                case 4:
                    maxRatingsLengthStylingWidth.value = "110px";
                    break;
                case 5:
                    maxRatingsLengthStylingWidth.value = "120px";
                    break;
                case 6:
                    maxRatingsLengthStylingWidth.value = "130px";
                    break;
                default:
                    maxRatingsLengthStylingWidth.value = "";
                    break;
            }
        }
        function processFilter(e, filterValue) {
            switch (e.target.dataset.filterType) {
                case FilterTypeEnum.Rating:
                    {
                        const isChecked = e.target.checked;
                        const index = store.selectedFilter.ratings.indexOf(parseInt(filterValue));
                        isChecked
                            ? store.selectedFilter.ratings.push(parseInt(filterValue))
                            : store.selectedFilter.ratings.splice(index, 1);
                    }
                    break;
                case FilterTypeEnum.Model:
                    {
                        const isChecked = e.target.checked;
                        const index = store.selectedFilter.models.indexOf(filterValue);
                        isChecked
                            ? store.selectedFilter.models.push(filterValue)
                            : store.selectedFilter.models.splice(index, 1);
                    }
                    break;
                case FilterTypeEnum.SurveyType:
                    {
                        store.selectedFilter.surveyType = filterValue;
                    }
                    break;
                default:
                    return;
            }
            store.processSelectedFilter();
        }
        return {
            maxRatingsLengthStylingWidth,
            defaultSurveyType,
            FilterTypeEnum,
            ratingFilterEnum,
            surveyTypeFilterEnum,
            ratingsContainer,
            filteredReviewsCount,
            filteredReviewsAverage,
            FullStarImage,
            HalfStarImage,
            EmptyStarImage,
            modelFilters,
            surveyTypeFilters,
            filteredStarCounts,
            processFilter,
        };
    },
});
